<template>
  <div class="csat">
    <BasePaneCard
      :isLoading="isLoading"
      heading="CSAT"
      unboxed
    >
      <div
        v-if="dataset.evaluation"
        class="csat__container"
      >
        <div
          class="csat__rating"
          :class="`csat__rating--${dataset.evaluation}`"
          :title="`Nota ${dataset.evaluation}`"
        >
          <div
            v-for="i in 5"
            :key="i"
            class="csat__rating__star"
          />
        </div>

        <div
          v-if="dataset.details"
          class="csat__comment"
        >
          "{{ dataset.details }}"
        </div>
      </div>

      <BaseEmptyState v-else>
        <template v-if="dataset.error">
          <SvgIconRobot/>

          <h3>
            Ops! Algo deu errado...
          </h3>

          <p>
            Por favor tente novamente.
          </p>
        </template>

        <template v-else>
          <h3>
            Este atendimento ainda<br>
            não recebeu CSAT.
          </h3>
        </template>
      </BaseEmptyState>
    </BasePaneCard>
  </div>
</template>

<script>
import { dateFilter } from '@/utils/filters'
import BasePaneCard from '@/components/base/BasePaneCard'
import BaseEmptyState from '@/components/base/BaseEmptyState'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'PartialLeadHistoryCsat',

  components: {
    BasePaneCard,
    BaseEmptyState
  },

  filters: {
    date: dateFilter
  },

  props: {
    leadId: Number,
    historyId: Number
  },

  data () {
    return {
      isLoading: false,
      dataset: {}
    }
  },

  computed: {
    ...mapState('base', ['mainApi'])
  },

  watch: {
    leadId () {
      this.fetchData()
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    getFetchDataParams () {
      let params = ''

      if (this.historyId) {
        params += `?history=${this.historyId}`
      }

      return params
    },

    async fetchData () {
      if (!this.leadId) {
        return
      }

      this.isLoading = true

      try {
        const params = this.getFetchDataParams()
        const url = `${this.mainApi}lead/lead-id-evaluation/${this.leadId}${params}`
        const response = await axios.get(url)

        this.dataset = response.data
      } catch (error) {
        this.dataset = { error }

        throw error
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.csat {
  /deep/ {
    .pane-card {
      &__body {
        // height: 100px;
        // overflow: hidden;
      }
    }

    .heading {
      &--small {
        font: {
          weight: 600;
          size: 14px;
        }
      }
    }
  }

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding-bottom: 20px;
  }

  &__rating {
    display: flex;
    align-items: center;

    &__star {
      width: 20px;
      height: 20px;
      margin: 0 2px;
      background: {
        image: url('~@/assets/img/main/icons/icon-rating-star-outline-component.svg');
        repeat: no-repeat;
        position: center;
        size: contain;
      }
    }

    &--1 & {
      &__star {
        &:first-child {
          background-image: url('~@/assets/img/main/icons/icon-rating-star-component.svg');
        }
      }
    }

    &--2 & {
      &__star {
        &:nth-child(-n + 2) {
          background-image: url('~@/assets/img/main/icons/icon-rating-star-component.svg');
        }
      }
    }

    &--3 & {
      &__star {
        &:nth-child(-n + 3) {
          background-image: url('~@/assets/img/main/icons/icon-rating-star-component.svg');
        }
      }
    }

    &--4 & {
      &__star {
        &:nth-child(-n + 4) {
          background-image: url('~@/assets/img/main/icons/icon-rating-star-component.svg');
        }
      }
    }

    &--5 & {
      &__star {
        background-image: url('~@/assets/img/main/icons/icon-rating-star-component.svg');
      }
    }
  }

  &__comment {
    font-size: 12px;
    line-height: 140%;
  }
}
</style>
